var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile.role != 'User' || (_vm.userSession && _vm.userSession.displayParameters && _vm.userSession.displayParameters.informations))?_c('span',[_c('FileDisplayer',{attrs:{"profile":_vm.profile,"user":_vm.user,"title":_vm.title,"category":_vm.category}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }